import { xmlRpcEndpoint } from '@/services/Authentication';
import {xmlRpcClient} from './client';


// Update instance
const replaceVoicemailAnnouncement = (data: any) => {
    const verbUpdate = 'instancename.replacevoicemailannouncement';
    const paramsUpdate = [
      {
        Mailbox: data.mailbox,
        BASE64: data.audio
      },
    ];
    return client(verbUpdate, paramsUpdate);
  };

const client = async (verb: any, params: any) => {
    const retData = await xmlRpcClient(xmlRpcEndpoint(), verb, params);
    return retData;
  };


export { replaceVoicemailAnnouncement };
